import { render } from "./CompaniesMode.vue?vue&type=template&id=a5033986"
import script from "./CompaniesMode.vue?vue&type=script&lang=js"
export * from "./CompaniesMode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__